export const get = (key) => {
    return JSON.parse(window.sessionStorage.getItem(key));
};

export const set = (key, value) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
};

export const remove = (key) => {
    window.sessionStorage.removeItem(key);
};

export const clearAll = () => {
    window.sessionStorage.clear();
};

export const sessionStorage = { get, set, remove, clearAll };
